import PageIndex from 'components/UI/PageIndex';
import {
  getAlertIdentifier,
  getAlertSource,
} from 'features/Weather/features/WeatherAlerts/utils/alertData.utils';
import { useDispatch, useSelector } from 'react-redux';
import FemaDetails from '../FemaAlertList/components/FemaDetails';
import FemaOptions from '../FemaAlertList/components/FemaOptions';
import AlertListHeader from './components/AlertListHeader/AlertListHeader';
import UserGeneratedAlertOptions from './components/UserGeneratedAlertOptions/UserGeneratedAlertOptions';
import AlertCard from './features/AlertCard/index.web';
import {
  selectFilteredAlertList,
  selectPageIndex,
  selectSortedPagedAlertList,
} from './state/selectors/alertListSelectors';
import { setPageIndex } from './state/slices/alertListSlice';
import styles from './AlertList.module.css';

const alertLimit = 100;

const AlertList = ({ title, perms, canDeleteAlerts }) => {
  const dispatch = useDispatch();
  const sortedPagedAlertList = useSelector(selectSortedPagedAlertList);
  const filteredAlertList = useSelector(selectFilteredAlertList);
  const pageIndex = useSelector(selectPageIndex);
  const canEditAlerts = perms.testPermission([8, 9, 10, 11, 12, 13], ['Create-EditAlerts']);

  return (
    <div className="d-flex h-100 min-h-0 flex-column overflow-hidden">
      <AlertListHeader title={title} perms={perms} />
      <div
        className={`${styles['alert-list-results']} customScrollbar-Y min-h-0 flex-grow-1 overflow-x-hidden overflow-y-auto p-2 ${
          !sortedPagedAlertList?.length ? 'overflow-hidden' : ''
        }`}
      >
        {sortedPagedAlertList?.length ? (
          sortedPagedAlertList?.map((alert, index) => {
            const alertId = getAlertIdentifier(alert, index);
            // Legacy FEMA rows (isLegacyFemaAlert) get the badge on the card, but keep the default
            // details and actions: they carry no stored IPAWS message to update or cancel.
            const isFemaAlert = getAlertSource(alert).value === 'fema';
            const isUserGeneratedAlert =
              alert?.alertSource !== 'fema' &&
              !!(alert && (alert.workplaceId || alert.globalActionId));
            return (
              <AlertCard
                key={alertId}
                index={index}
                alert={alert}
                renderDetails={isFemaAlert ? <FemaDetails alert={alert} /> : undefined}
                renderActions={
                  isFemaAlert ? (
                    <FemaOptions alert={alert} />
                  ) : isUserGeneratedAlert ? (
                    <UserGeneratedAlertOptions
                      alert={alert}
                      canEditAlerts={canEditAlerts}
                      canDeleteAlerts={canDeleteAlerts}
                    />
                  ) : undefined
                }
              />
            );
          })
        ) : (
          <p className="w-100 py-3 text-center">No Results Found...</p>
        )}
      </div>
      <div className="flex-shrink-0 border-top border-theme-strong mt-2 pt-2">
        <PageIndex
          pageIndex={pageIndex}
          setPageIndex={(value) => dispatch(setPageIndex(value))}
          maxPages={filteredAlertList?.length / alertLimit}
        />
      </div>
    </div>
  );
};

export default AlertList;
